// Deliberately long: it must outlast the worst LEGITIMATE tail — a human deliberating on the native
// ATT consent dialog is a real wait, not a hang — while staying under the point where a user
// concludes the app is dead.
export const BOOT_WATCHDOG_MS = 20_000;

// Must NEVER trigger a revert: a hung SDK is not a broken bundle, so this module imports no
// crashRecovery/renderHealth/CapacitorUpdater and has nothing to call reset() with.
export const armBootWatchdog = (onExpire: () => void): (() => void) => {
  const timer = setTimeout(onExpire, BOOT_WATCHDOG_MS);
  return () => clearTimeout(timer);
};
